// eslint-disable-next-line
/// <reference path="../pug.d.ts" />
// @ts-check
'use strict';

const escapeHtml = require('stringify-entities').escape;

// NOTE: node 6 の神ゲームエディターでは padStart が使えないので自前で実装する
/**
 * @param {string} str
 * @param {number} targetLength
 * @returns {string}
 */
const zeroPadding = (str, targetLength) => {
  if (str.length >= targetLength) {
    return str;
  }

  const padLength = targetLength - str.length;
  const pad = '0'.repeat(padLength);
  return pad + str;
};

const escapedClosingTagStart = '</'
  .split('')
  // @ts-ignore
  .map((c) => '\\' + zeroPadding(c.codePointAt(0).toString(16), 6))
  .join('');

/**
 * @param {string} css
 * @returns {string}
 */
const escapeCSS = (css) => {
  // NOTE: インジェクションを防ぎたいので閉じタグの </ をエスケープする
  // REF: https://www.w3.org/International/questions/qa-escapes#cssescapes
  return css.replace(/<\//g, escapedClosingTagStart);
};

/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const escapeAst = (node) => {
  // NOTE: pug はデフォルトで html 属性値のエスケープを行ってくれるので、属性値のエスケープは不要
  // REF: https://pugjs.org/language/attributes.html

  if (node.type !== 'Tag') {
    return node;
  }

  if (!('block' in node) || !node.block) {
    return node;
  }

  if (node.name === 'style') {
    return {
      ...node,
      block: {
        ...node.block,
        nodes: node.block.nodes.map((child) => {
          if (child.type === 'Text') {
            return {
              ...child,
              val: escapeCSS(child.val),
            };
          }

          return child;
        }),
      },
    };
  }

  return {
    ...node,
    block: {
      ...node.block,
      nodes: node.block.nodes.map((child) => {
        if (child.type === 'Text') {
          return {
            ...child,
            val: escapeHtml(child.val),
          };
        }

        return child;
      }),
    },
  };
};

exports.escapeAst = escapeAst;
